<template>
  <v-container fluid>
    <!-- <v-row align="center">
      <v-col class="pb-0 pt-0">
        <v-tabs v-model="selectedTab">
          <v-tab> PROJECTS </v-tab>
          <v-tab> PROJECTS SCOPE </v-tab>
        </v-tabs>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col
        class="pb-0 pt-0"
        cols="auto"
      >
        <v-tabs
          v-model="selectedTab"
        >
          <v-tab>
            ACTIVE
          </v-tab>
          <v-tab>
            ARCHIVED
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <!-- <v-col
            cols="2"
            class="pb-0 pt-4"
          >
            <inventory-class-select-element
              v-model="inventoryClassId"
              :is-state="true"
            />
          </v-col> -->
          <v-col
            cols="2"
            class="pt-1"
          >
            <v-select
              v-model="filterCompletion"
              :items="completionOptions"
              item-text="text"
              item-value="value"
              label="Completion"
              clearable
              prepend-inner-icon="mdi-progress-check"
            />
          </v-col>
          <v-spacer />
          <!-- Schedule Screen Schedules Button for Testing -->
          <v-col
            cols="auto"
            class="pl-0 pt-1"
          >
            <v-btn
              v-if="roles.includes(userRoleIdAdmin) && !isDesa()"
              color="warning"
              outlined
              @click="scheduleScreenSchedules"
            >
              Schedule Screen Schedules
            </v-btn>
          </v-col>
          <v-col
            cols="auto"
            class="pl-0 pt-1"
          >
            <v-btn
              v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdReadWrite)"
              color="primary"
              outlined
              @click="open"
            >
              <v-icon
                small
                class="mr-1"
              >
                fas fa-plus
              </v-icon>
              New Project
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <v-card
              elevation="0"
              outlined
              style="height: calc(100% + 24px)"
            >
              <v-data-table
                :headers="headers"
                :items="items"
                :footer-props="footer"
                :items-per-page="pagination.itemsPerPage"
                :search="search"
                :loading="loading"
                dense
                fixed-header
                :height="windowHeight"
                :server-items-length="total"
                :item-class="getProjectRowClass"
                @update:options="updateOptions"
              >
                <!-- <template #[`item.class`]="{ item }">
                  <v-chip
                    v-if="item.class"
                    small
                    :color="item && item.class ? item.class.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.class ? item.class.name : '' }}
                  </v-chip>
                </template> -->
                <template #[`item.name`]="{ item }">
                  <text-highlight
                    :queries="search"
                    style="font-weight: bold"
                  >
                    {{ item.name }}
                  </text-highlight>
                </template>
                <template #[`item.client`]="{ item }">
                  <text-highlight :queries="search">
                    {{ item.client ? item.client.name : '' }}
                  </text-highlight>
                </template>
                <template #[`item.address`]="{ item }">
                  <v-tooltip
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span v-on="on">
                        <text-highlight :queries="search">
                          {{
                            item.address_simple ? item.address_simple : ''
                          }}
                        </text-highlight>
                      </span>
                    </template>

                    <text-highlight :queries="search">
                      {{ item.address_full ? item.address_full : '' }}
                    </text-highlight>
                  </v-tooltip>
                </template>
                <template #[`item.completion`]="{ item }">
                  <text-highlight :queries="search">
                    {{ formatCompletion(item.completion) }}
                  </text-highlight>
                </template>
                <template #[`item.actions`]="{ item }">
                  <v-btn
                    v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdReadWrite) || roles.includes(userRoleIdPaintHandler)"
                    class="ml-1 mt-1 mb-1"
                    color="purple"
                    outlined
                    small
                    @click="toggle(item)"
                  >
                    {{ item.is_archived === 0 ? 'ARCHIVE' : 'ACTIVATE' }}
                  </v-btn>
                  <v-btn
                    v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdReadWrite)"
                    class="ml-1 mt-1 mb-1"
                    color="primary"
                    outlined
                    small
                    @click="openEdit(item.id)"
                  >
                    EDIT
                  </v-btn>
                  <v-btn
                    v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdReadWrite)"
                    class="ml-1 mt-1 mb-1 mr-1"
                    color="error"
                    outlined
                    small
                    @click="softDelete(item.id)"
                  >
                    DELETE
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <project-form
      ref="projectForm"
      @success="success"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import ProjectForm from '@/components/forms/projects/ProjectForm';
import { mapState } from 'vuex';
import { isDesa } from '../../composables/desa';

export default {
  components: {
    ProjectForm,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'ID', value: 'id', width: '5%' },
      { text: 'Project Name', value: 'name', width: '15%' },
      { text: 'Client', value: 'client', width: '22%' },
      { text: 'Job Address', value: 'address', width: '15%' },
      { text: 'Floors', value: 'floor_count', width: '5%', align: 'center' },
      { text: 'Completion', value: 'completion', width: '5%', align: 'center' },
      { text: 'Created At', value: 'created_at_short', width: '10%' },
      { text: 'Created By', value: 'user_full_name', width: '7%' },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '300px',
        sortable: false,
      },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    rowsPerPageItems: [10, 20, 50, 100, 500, 1000],
    loading: false,
    topSpaceHeight: 235,
    windowHeight: 1000,
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    total: 0,
    selectedTab: 0,
    table: 'projectView',
    // inventoryClassId: null,
    sort: {
      order_by_first: 'created_at',
      direction_sort: true,
    },
    userRoleIdAdmin: 3,
    userRoleIdReadWrite: 2,
    userRoleIdPaintHandler: 26,
    roles: [],
    filterCompletion: null,
    completionOptions: [
      { text: '0%', value: 0 },
      { text: '25%', value: 25 },
      { text: '50%', value: 50 },
      { text: '75%', value: 75 },
      { text: '100%', value: 100 },
    ],
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      projectsState: (state) => state.projectsState,
      user: (state) => state.user,
    }),
  },
  watch: {
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
    // inventoryClassId() {
    //   this.get();
    // },
    sort: {
      handler() {
        this.get();
      },
      deep: true,
    },
    selectedTab() {
      this.get();
    },
    filterCompletion() {
      this.get();
    },
    // 'sort.order_by_first': 'get',
    // 'sort.direction_sort': 'get',
  },
  created() {
    if (this.projectsState) {
      if (this.projectsState.pagination) {
        this.pagination = this.projectsState.pagination;
      }
    }
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.roles = this.user.roles.map((x) => x.id);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    isDesa() {
      return isDesa();
    },
    storeState(property, value) {
      const state = this.projectsState;
      state[property] = value;
      this.$store.commit('storeProjectsState', state);
    },

    init() {
      this.get();
    },

    async get() {
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: { is_archived: this.selectedTab, completion: this.filterCompletion },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.project.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (!res || !res.data) {
        this.$bus.$emit('showError');
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.project.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.projectForm.open();
    },

    openEdit(id) {
      this.$refs.projectForm.open(id);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },

    hasCompletion(completion) {
      return completion !== null && completion !== undefined && completion !== '';
    },

    formatCompletion(completion) {
      return this.hasCompletion(completion) ? `${completion}%` : '';
    },

    getProjectRowClass(item) {
      if (!item || !this.hasCompletion(item.completion)) {
        return '';
      }

      const completion = parseFloat(item.completion);

      if (Number.isNaN(completion)) {
        return '';
      }

      if (completion >= 100) return 'project-row-completion-100';
      if (completion >= 75) return 'project-row-completion-75';
      if (completion >= 50) return 'project-row-completion-50';
      if (completion >= 25) return 'project-row-completion-25';
      return 'project-row-completion-0';
    },

    async toggle(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to ${item.is_archived === 0 ? 'Archive' : 'Active'} this Project?`,
      });
      if (!confirm) return;
      const isActive = item.is_archived === 1 ? 0 : 1;
      const res = await this.$api.project.get(`toggle/${item.id}/${isActive}`);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async scheduleScreenSchedules() {
      const res = await this.$api.project.get('schedule/screen-schedules');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess', 'Screen schedules have been scheduled successfully.');
    },
  },
};
</script>
<style scoped>
::v-deep .project-row-completion-0 {
  background-color: #ffebee !important;
}

::v-deep .project-row-completion-25 {
  background-color: #fff3e0 !important;
}

::v-deep .project-row-completion-50 {
  background-color: #fffde7 !important;
}

::v-deep .project-row-completion-75 {
  background-color: #e3f2fd !important;
}

::v-deep .project-row-completion-100 {
  background-color: #e8f5e9 !important;
}
</style>
